<template>
  <canvas class="escalon-absolute-center" ref="canvas"></canvas>
</template>

<script>
import CanvasRenderer from "../canvasRenderer";
export default {
  name: "canvasBase",
  props: {
    imgSize: Object,
    canvasSize: Object,
    transform: Object,
    isFlipped: Boolean,
    isFlipped90: Boolean,
    isFlipped270: Boolean,
    flippedX: Boolean,
    name: String,
    autodraw: { type: Boolean, default: true },
    isDeepDeeAnnotation: Boolean,
    forceTranslate: Boolean
  },
  data() {
    return {
      renderer: null
    };
  },
  methods: {
    redraw() {
      return this.$nextTick().then(this.draw);
    },
    createRenderer() {
      this.renderer = new CanvasRenderer(this.$refs.canvas);
      this.renderer.canvasSize = this.canvasSize;
      this.renderer.transform = this.transform;
      this.renderer.imgSize = this.imgSize;
      this.renderer.isFlipped = this.isFlipped;
      this.renderer.isFlipped90 = this.isFlipped90;
      this.renderer.isFlipped270 = this.isFlipped270;
      this.renderer.flippedX = this.flippedX;
      this.renderer.name = this.name;
      this.renderer.isDeepDeeAnnotation = this.isDeepDeeAnnotation;
      this.renderer.forceTranslate = this.forceTranslate;
      this.setupDrawCall();
      if (this.autodraw) this.redraw();
    },
    setupDrawCall(){}
  },
  watch: {
    canvasSize: {
      handler() {
        if (this.canvasSize && this.canvasSize !== this.renderer.canvasSize)
          this.renderer.canvasSize = this.canvasSize;

        if (this.autodraw) this.redraw();
      },
      deep: true
    },
    transform: {
      handler() {
        if (this.transform && this.transform !== this.renderer.transform)
          this.renderer.transform = this.transform;

        if (this.autodraw) this.redraw();
      },
      deep: true
    },
    imgSize: {
      handler() {
        if (this.imgSize && this.imgSize !== this.renderer.imgSize)
          this.renderer.imgSize = this.imgSize;

        if (this.autodraw) this.redraw();
      },
      deep: true
    },
    isFlipped(){
      if (this.isFlipped !== this.renderer.isFlipped)
        this.renderer.isFlipped = this.isFlipped;

      if (this.autodraw) this.redraw();
    },
    isFlipped90(){
      if (this.isFlipped90 !== this.renderer.isFlipped90)
        this.renderer.isFlipped90 = this.isFlipped90;

      if (this.autodraw) this.redraw();
    },
    isFlipped270(){
      if (this.isFlipped270 !== this.renderer.isFlipped270)
        this.renderer.isFlipped270 = this.isFlipped270;

      if (this.autodraw) this.redraw();
    },
    flippedX(){
      if (this.flippedX !== this.renderer.flippedX)
        this.renderer.flippedX = this.flippedX;

      if (this.autodraw) this.redraw();
    }
  },
  mounted() {
    this.createRenderer();
    if (this.autodraw) this.redraw();
  }
};
</script>
